module.exports = __webpack_public_path__ + "img/13.598f5db6.png";